import { EventBus } from '@/event-bus.js'

const state = {
  isLoading: false,
  appLoaded: false
}

const getters = {
  isLoading: state => state.isLoading,
  appLoaded: state => state.appLoaded
}

const mutations = {
  SET_LOADING (state, loading) {
    state.isLoading = loading
  },
  SET_APP_LOADED (state, loading) {
    state.appLoaded = loading
    if (loading === true) {
      EventBus.$emit('AppLoaded')
    }
  }
}

const actions = {
  SetLoading ({
    commit
  }, loading) {
    commit('SET_LOADING', loading)
  },
  SetAppLoaded ({
    commit
  }, loading) {
    commit('SET_APP_LOADED', loading)
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
